import {
  ClockIcon,
  CreditCardIcon,
  DesktopComputerIcon,
  HeartIcon,
  ShoppingCartIcon,
  UserGroupIcon
} from '@heroicons/react/outline'
import React from 'react'

const features = [
  {
    name: 'Streamlined Requests',
    description:
      'With our quick and simple online catering form, you can request food trucks for your next event in a matter of minutes, specifying your guest count, budget and dates.',
    icon: ShoppingCartIcon
  },
  {
    name: 'Choose Your Favorites',
    description:
      'After you submit a catering request to us, our team will check availability for you and send over a list of amazing food truck menus to browse through (try not to drool).',
    icon: HeartIcon
  },
  {
    name: 'Simplified Payments',
    description:
      "Once you've decided on which truck you'd like to book, confirming them is as easy as clicking a button. All payments are handled securely on our website for ease of booking.",
    icon: CreditCardIcon
  },
  {
    name: 'Pre-Ordering',
    description:
      'If your meal time is limited, our staff will work with you to coordinate an online pre-order system where meals are predetermined and handed out hot during service.',
    icon: ClockIcon
  },
  {
    name: 'Support Team',
    description:
      "Our dedicated support team will be with you every step of the way from planning to organizing to grubbing your little heart out. With every event you'll have a dedicated member of our team available in case anything should arise.\n",
    icon: UserGroupIcon
  },
  {
    name: 'Corporate Portal',
    description:
      'With customizable features, executives can set up their own account, add a credit card and let their employees order as they want from the food truck or set spending limits.',
    icon: DesktopComputerIcon
  }
]

const FeatureSection = () => {
  return (
    <div className="w-full mx-auto bg-gradient-to-r bg-white">
      <div className="max-w-7xl mx-auto md:px-4 pt-4">
        <div className="relative py-16 sm:py-24 lg:py-32">
          <div className="mx-auto max-w-md px-4 text-center sm:max-w-3xl lg:max-w-7xl">
            <p className="mt-2 text-3xl font-extrabold text-gray-900 tracking-tight sm:text-4xl">
              Our features
            </p>
            <div className="mt-12">
              <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
                {features.map((feature) => (
                  <div key={feature.name} className="pt-6">
                    <div className="flow-root bg-gray-50 rounded-lg px-6 pb-8">
                      <div className="-mt-6">
                        <div>
                          <span className="inline-flex items-center justify-center p-3 bg-gradient-to-r from-orange-400 to-orange-600 rounded-md shadow-lg">
                            <feature.icon
                              aria-hidden="true"
                              className="h-6 w-6 text-white"
                            />
                          </span>
                        </div>
                        <h3 className="mt-8 text-lg font-medium text-gray-900 tracking-tight">
                          {feature.name}
                        </h3>
                        <p className="mt-5 text-base text-gray-500">
                          {feature.description}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FeatureSection
